(function () {
  'use strict';

  if (window.__gs509aLandingLoaded) return;
  window.__gs509aLandingLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safePlay(video) {
    if (!video) return;
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseMedia(container) {
    if (!container) return;
    container.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function playMedia(container) {
    if (!container || reduceMotion) return;
    container.querySelectorAll('video[autoplay]').forEach(safePlay);
  }

  function setupAmbientMedia(root) {
    var scope = root || document;
    var media = scope.querySelectorAll(
      '.gs509a-card video, .gs509a-feature-row video, .gs509a-grid-card video'
    );

    if (!('IntersectionObserver' in window)) {
      media.forEach(safePlay);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && video.hasAttribute('autoplay') && !reduceMotion) {
            safePlay(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.35, 0.75] }
    );

    media.forEach(function (video) {
      if (video.dataset.gs509aObserved === 'true') return;
      video.dataset.gs509aObserved = 'true';
      observer.observe(video);
    });
  }

  if (!customElements.get('gs509a-slider')) {
    customElements.define(
      'gs509a-slider',
      class GS509ASlider extends HTMLElement {
        connectedCallback() {
          if (this.dataset.gs509aReady === 'true') return;
          this.dataset.gs509aReady = 'true';

          this.type = this.dataset.sliderType || 'stage';
          this.transition = this.dataset.transition || 'slide';
          this.track = this.querySelector('[data-slider-track]');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slider-slide]'));
          this.previousButton = this.querySelector('[data-slider-previous]');
          this.nextButton = this.querySelector('[data-slider-next]');
          this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-slider-dot]'));
          this.index = Math.max(0, this.slides.findIndex(function (slide) {
            return slide.classList.contains('is-active');
          }));
          this.scrollFrame = 0;
          this.autoplayTimer = 0;
          this.pointerStartX = null;
          this.pointerStartY = null;

          if (!this.track || this.slides.length === 0) return;

          this.bindControls();
          this.bindKeyboard();
          this.bindPointerGestures();
          this.bindEditorEvents();

          if (this.type === 'cards') {
            this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
          }

          this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
          this.addEventListener('mouseleave', this.startAutoplay.bind(this));
          this.addEventListener('focusin', this.stopAutoplay.bind(this));
          this.addEventListener('focusout', this.startAutoplay.bind(this));
          document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this));

          this.goTo(this.index, false);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
        }

        bindControls() {
          var slider = this;

          if (this.previousButton) {
            this.previousButton.addEventListener('click', function () {
              slider.goTo(slider.index - 1, true);
            });
          }

          if (this.nextButton) {
            this.nextButton.addEventListener('click', function () {
              slider.goTo(slider.index + 1, true);
            });
          }

          this.dots.forEach(function (dot, index) {
            dot.addEventListener('click', function () {
              slider.goTo(index, true);
            });
          });
        }

        bindKeyboard() {
          var slider = this;
          this.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              slider.goTo(slider.index - 1, true);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              slider.goTo(slider.index + 1, true);
            } else if (event.key === 'Home') {
              event.preventDefault();
              slider.goTo(0, true);
            } else if (event.key === 'End') {
              event.preventDefault();
              slider.goTo(slider.slides.length - 1, true);
            }
          });
        }

        bindPointerGestures() {
          if (this.type === 'cards' || this.dataset.swipe === 'false') return;
          var slider = this;

          this.track.addEventListener('pointerdown', function (event) {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            if (event.target.closest('a, button, input, select, textarea')) return;
            slider.pointerStartX = event.clientX;
            slider.pointerStartY = event.clientY;
          });

          this.track.addEventListener('pointerup', function (event) {
            if (slider.pointerStartX === null) return;
            var deltaX = event.clientX - slider.pointerStartX;
            var deltaY = event.clientY - slider.pointerStartY;
            slider.pointerStartX = null;
            slider.pointerStartY = null;

            if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
            slider.goTo(slider.index + (deltaX < 0 ? 1 : -1), true);
          });

          this.track.addEventListener('pointercancel', function () {
            slider.pointerStartX = null;
            slider.pointerStartY = null;
          });
        }

        bindEditorEvents() {
          var slider = this;
          document.addEventListener('shopify:block:select', function (event) {
            var blockId = event.detail && event.detail.blockId;
            if (!blockId || !slider.contains(event.target)) return;
            var index = slider.slides.findIndex(function (slide) {
              return slide.dataset.blockId === blockId;
            });
            if (index >= 0) {
              slider.stopAutoplay();
              slider.goTo(index, true);
            }
          });
        }

        onVisibilityChange() {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        }

        onScroll() {
          var slider = this;
          if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = window.requestAnimationFrame(function () {
            var trackRect = slider.track.getBoundingClientRect();
            var closestIndex = 0;
            var closestDistance = Infinity;

            slider.slides.forEach(function (slide, index) {
              var distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            slider.index = closestIndex;
            slider.updateControls();
          });
        }

        normalizeIndex(index) {
          if (this.dataset.loop === 'true') {
            return (index + this.slides.length) % this.slides.length;
          }
          return Math.max(0, Math.min(index, this.slides.length - 1));
        }

        goTo(index, animate) {
          this.index = this.normalizeIndex(index);

          if (this.type === 'cards') {
            var target = this.slides[this.index];
            if (target) {
              this.track.scrollTo({
                left: target.offsetLeft - this.track.offsetLeft,
                behavior: animate && !reduceMotion ? 'smooth' : 'auto'
              });
            }
          } else if (this.transition === 'fade') {
            this.slides.forEach(function (slide, slideIndex) {
              var isActive = slideIndex === this.index;
              slide.classList.toggle('is-active', isActive);
              slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
              slide.inert = !isActive;
              pauseMedia(slide);
              if (isActive) playMedia(slide);
            }, this);
          } else {
            this.track.style.transform = 'translate3d(-' + (this.index * 100) + '%, 0, 0)';
            this.slides.forEach(function (slide, slideIndex) {
              var isActive = slideIndex === this.index;
              slide.classList.toggle('is-active', isActive);
              slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
              slide.inert = !isActive;
              pauseMedia(slide);
              if (isActive) playMedia(slide);
            }, this);
          }

          this.updateControls();
          this.restartAutoplay();
        }

        updateControls() {
          var isLooping = this.dataset.loop === 'true';

          if (this.previousButton) {
            this.previousButton.disabled = !isLooping && this.index <= 0;
          }

          if (this.nextButton) {
            if (this.type === 'cards') {
              var maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
              this.nextButton.disabled = !isLooping && this.track.scrollLeft >= maxScroll;
            } else {
              this.nextButton.disabled = !isLooping && this.index >= this.slides.length - 1;
            }
          }

          this.dots.forEach(function (dot, index) {
            dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
          }, this);
        }

        startAutoplay() {
          if (this.dataset.autoplay !== 'true' || reduceMotion || this.slides.length < 2 || document.hidden) return;
          if (this.autoplayTimer) return;
          var slider = this;
          var delay = Math.max(2500, Number(this.dataset.autoplayDelay || 6000));
          this.autoplayTimer = window.setInterval(function () {
            if (!slider.matches(':hover') && !slider.contains(document.activeElement)) {
              slider.goTo(slider.index + 1, true);
            }
          }, delay);
        }

        stopAutoplay() {
          if (!this.autoplayTimer) return;
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = 0;
        }

        restartAutoplay() {
          if (!this.autoplayTimer) return;
          this.stopAutoplay();
          this.startAutoplay();
        }
      }
    );
  }

  function boot(root) {
    setupAmbientMedia(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
